#
# This tiny concern controls the switch of file uploader allowing you to
# either upload file or select a pre-uploaded file
#
class @FileUploadSelection

  @setup: (idPrefix) ->
    # Get references to the various fields on the page that have to do with the
    # file options.

    $localFileSource        = $("##{idPrefix}_file_source_local")
    $uploadFileSource       = $("##{idPrefix}_file_source_upload")
    $urlFileSource          = $("##{idPrefix}_file_source_url")
    $fileLocal              = $("##{idPrefix}_file_local_path")
    $fileUpload             = $("##{idPrefix}_file")
    $fileUrl                = $("##{idPrefix}_file_url")
    $form                   = $localFileSource.closest("form")

    # Don't continue if the fields we're looking for aren't on this page.

    return if $localFileSource.length == 0 || $uploadFileSource.length == 0
    return if $form.length == 0

    # Build the callback for when the option is changed.

    adjustForFileSource = ->
      if $uploadFileSource.is(":checked")
        $fileLocal.closest(".form-field").hide().find("select").attr(enabled: false)
        $fileUpload.closest(".form-field").show().find("select").attr(enabled: true)
        $fileUrl.closest(".form-field").hide().find("input").attr(enabled: false)
      else if $urlFileSource.is(":checked")
        $fileLocal.closest(".form-field").hide().find("select").attr(enabled: false)
        $fileUpload.closest(".form-field").hide().find("select").attr(enabled: false)
        $fileUrl.closest(".form-field").show().find("input").attr(enabled: true)
      else
        $fileLocal.closest(".form-field").show().find("select").attr(enabled: true)
        $fileUpload.closest(".form-field").hide().find("select").attr(enabled: false)
        $fileUrl.closest(".form-field").hide().find("input").attr(enabled: false)

    # Initialize the form.

    $localFileSource.change(adjustForFileSource)
    $uploadFileSource.change(adjustForFileSource)
    $urlFileSource.change(adjustForFileSource)

    adjustForFileSource()
